/*
* @Author: Gang Jiang
* @Date: 2024-09-19 22:49:39
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-10-11 15:53:49
*/

<template>
  <div class="commission-component">
    <a-table
      :data-source="commissionList"
      :columns="commissionColumn"
      :pagination="false"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'newCpaBeginTime'">
          <div class="effective-time">
            <span
              v-if="record.newCpaBeginTime"
            >{{ moment(record.newCpaBeginTime).format('YYYY-MM-DD HH:mm:ss') }}
              -
              {{
                moment(record.newCpaEndTime).format('YYYY-MM-DD HH:mm:ss')
              }}</span>
            <span v-else>-</span>
          </div>
        </template>
        <template v-else-if="column.key === 'newCpaDesc'">
          <div class="commission-data">
            <span v-if="record.newCpaDesc && record.newCpaDesc.length">{{
              record.newCpaDesc
            }}</span>
            <span v-else>-</span>
          </div>
        </template>
        <template v-else-if="column.key === 'newCpaForKol'">
          <div class="commission-data">
            <span v-if="record.newCpaForKol && record.newCpaForKol.length">{{
              record.newCpaForKol
            }}</span>
            <span v-else>-</span>
          </div>
        </template>
        <template v-else-if="column.key === 'cpaForKol'">
          <div class="commission-data">
            <span v-if="record.cpaForKol && record.cpaForKol.length">{{
              record.cpaForKol
            }}</span>
            <span v-else>-</span>
          </div>
        </template>
        <template v-else-if="column.key === 'note'">
          <div class="commission-data">
            <span v-if="record.note && record.note.length">{{
              record.note
            }}</span>
            <span v-else>-</span>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    commissionList: { type: Array, default: () => [] },
  },
  data() {
    return {
      moment,
      commissionColumn: [
        {
          title: 'Commission Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'CPA',
          dataIndex: 'cpaDesc',
          key: 'cpaDesc',
        },
        {
          title: 'CPA for KOL',
          dataIndex: 'cpaForKol',
          key: 'cpaForKol',
        },
        {
          title: 'New CPA',
          dataIndex: 'newCpaDesc',
          key: 'newCpaDesc',
        },
        {
          title: 'New CPA for KOL',
          dataIndex: 'newCpaForKol',
          key: 'newCpaForKol',
        },
        {
          title: 'New CPA effective time',
          dataIndex: 'newCpaBeginTime',
          key: 'newCpaBeginTime',
        },
        {
          title: 'Note',
          dataIndex: 'note',
          key: 'note',
          width: 300
        },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.commission-component {
  :deep(.ant-table) {
    &-container {
      border-inline-start: none !important;
    }
    table {
      border-top: none !important;
    }
    &-cell:last-of-type {
      border-inline-end: none !important;
    }
  }
}
</style>